import React from "react";
import { CopyToClipboard } from "../../../../components";
import { prepareHashNotificationText } from "./utils";

type HashRowProps = {
  hashName: string;
  hashValue?: string;
};

const HashRow = ({ hashName, hashValue }: HashRowProps) => (
  <div className="hash-row">
    <span className="hash-name">{hashName} </span>
    <div className="hash-container">
      <div className="hash-wrapper">
        <CopyToClipboard
          value={hashValue}
          subjectText={prepareHashNotificationText(hashName)}
          className="me-10"
        />
        <span id={`hash-value-span-${hashName}`} className="hash-value">
          {hashValue}
        </span>
      </div>
    </div>
  </div>
);

export default HashRow;
